import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../Layout/Main/header/Header";
import Footer from "../../Layout/Main/footer/FooterTwo";
const Content = [
{
    subTitle: 'What is Included in Full-Service Move?',
    PreContent: 'In a full-service move, we take care of most of your work like',
    ListContent: [
        "Packing all of your possessions into small boxes",
        "Full disassembling of your furniture like bed frames and mirrors on dressers etc.",
        "Loading all your furniture into our moving trucks.",
        "Moving all your stuff to your desired location.",
        "Placing all the boxes in your desired rooms and re-assembling all the things that were disassembled before.",
        "Unpacking all the boxes and place the things on your desired spots."
    ],
    PostContent: 'In a full-service move, we take care of most of your work like',
    id: 1
},
{
    subTitle: 'What is Included in Partial Move Service?',
    PreContent: 'The partial move involves the following services',
    ListContent: [
        "Loading all of your furniture (blanket wrapped) and boxes that you have already packed into our moving trucks.",
        "Full disassembling of your furniture like bed frames and mirrors on dressers etc.",
        "Delivering these items directly into your new home in the room of your choice.",
        
    ],
    PostContent: '',
    id: 2
},
{
    subTitle: 'Our Goal',
    PreContent: 'Our goal is to provide you with peace of mind. Moving could be a very stressful thing to do but with our help, you won’t have to worry. We always focus on providing you the high-quality services from packing to transport to storage so that you can easily settle in your new house without making any efforts. We have professional staff to guide you step by step on the way to make sure that you feel comfortable and in control throughout your move.',
    ListContent: [
        "",
    ],
    PostContent: '',
    id: 3
},
{
    subTitle: 'First pack essential things',
    PreContent: 'In a full-service move, we take care of most of your work like',
    ListContent: [
        "Packing all of your possessions into small boxes",
        "Full disassembling of your furniture like bed frames and mirrors on dressers etc.",
        "Loading all your furniture into our moving trucks.",
        "Moving all your stuff to your desired location.",
        "Placing all the boxes in your desired rooms and re-assembling all the things that were disassembled before.",
        "Unpacking all the boxes and place the things on your desired spots."
    ],
    PostContent: 'In a full-service move, we take care of most of your work like',
    id: 4
},
];
class LocalMoving extends Component{
    render(){
        let title = 'Local Moving Services in Greater Vancouver';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Local Moving Services?' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-8 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <Breadcrumb title={'Local Moving'}/>
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50"> Are you planning a local move within Greater Vancouver? You can trust <a href="/">Moonline</a> to make your move smooth and effortless. We have a team of highly trained individuals having years of experience in this field. We are committed to providing our customers with high-quality services which means that we always go the extra mile to satisfy our clients. We know all the Greater Vancouver areas such as Vancouver, Burnaby, Surrey, Coquitlam, North Vancouver, Richmond, Langley very well which means that we will engage those individuals for your work who are already aware of your neighborhood to ensure an efficient and smooth move. It doesn’t matter if you are moving to or from a farmhouse, apartment, or condo, house, or moving to a retirement community, we have experts get your belongings to your destination safe and sound. We have been serving our clients to make their next move as smooth and painless as possible. We are with you every step in the way. </p>
                                            <p className="description text-left pt--50">Local moving may involve moving a few items in the same building or a full home or office across the town. With our wide variety of moving services, we are able to meet all your moving needs. </p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Local Moving Services in Greater Vancouver</h3>
                                        </div>                            
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--50"> Moonline also provides its services in other areas of British Columbia like Victoria, Abbotsford, Vancouver Island, including Duncan, Nanaimo, Parksville, Courtenay, and Campbell River. If you are moving to or from any location outside the Greater Vancouver area or surrounding areas, simply give us a call for a free no obligation quote, and one of our professional client managers will guide you through the whole process. Or simply fill in the <a href="/clientinformation">moving free quote form</a> and we will get back to you within 24 hours of submitting your request. If you want to move outside of BC then you can refer to our <a href="/longmoving"><b>Long Distance Moving Page</b></a>. </p>
                                                <p className="description text-left pt--50">We offer 2 Types of Local Moving Services </p>
                                                <ul style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                    <li> A full-service Move</li>
                                                    <li>A partial Service Move</li>
                                                </ul>                                  
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>What is Included in Full-Service Move?</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30"> In a full-service move, we take care of most of your work like</p>
                                                
                                                <ol style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                    <li>Packing all of your possessions into small boxes.</li>
                                                    <li>Full disassembling of your furniture like bed frames and mirrors on dressers etc.</li>
                                                    <li>Loading all your furniture into our moving trucks.</li>
                                                    <li>Moving all your stuff to your desired location.</li>
                                                    <li>Placing all the boxes in your desired rooms and re-assembling all the things that were disassembled before.</li>
                                                    <li>Unpacking all the boxes and place the things on your desired spots.</li>
                                                </ol>
                                                <p className="description text-left">This kind of moving can take 2 days depending upon the size of your move and is charged at an hourly rate based on the manpower required.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">             
                                            <h3 className="text-left" style={{lineHeight:1.5}}>What is Included in Partial Move Service?</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">The partial move involves the following services</p>
                                                <ol style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                    <li>Loading all of your furniture (blanket wrapped) and boxes that you have already packed into our moving trucks.</li>
                                                    <li>Delivering these items directly into your new home in the room of your choice.</li>
                                                </ol>
                                                <p className="description text-left">This kind of moving can take 2 days depending upon the size of your move and is charged at an hourly rate based on the manpower required.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Our Goal</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">Our goal is to provide you with peace of mind. Moving could be a very stressful thing to do but with our help, you won’t have to worry. We always focus on providing you the high-quality services from packing to transport to storage so that you can easily settle in your new house without making any efforts. We have professional staff to guide you step by step on the way to make sure that you feel comfortable and in control throughout your move.</p>    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>What is Included in Partial Move Service?</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">The partial move involves the following services</p>
                                                
                                                <ol style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                    <li>Loading all of your furniture (blanket wrapped) and boxes that you have already packed into our moving trucks.</li>
                                                    <li>Delivering these items directly into your new home in the room of your choice</li>
                                                </ol>
                                                <p className="description text-left">This kind of moving can take 2 days depending upon the size of your move and is charged at an hourly rate based on the manpower required.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Our Goal</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">Our goal is to provide you with peace of mind. Moving could be a very stressful thing to do but with our help, you won’t have to worry. We always focus on providing you the high-quality services from packing to transport to storage so that you can easily settle in your new house without making any efforts. We have professional staff to guide you step by step on the way to make sure that you feel comfortable and in control throughout your move.</p>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Why Choose Us As You Local Moving Partner?</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">There are several reasons for trusting our services such as</p>                                          
                                                <ol style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                    <li>Completely <a href="/clientinformation"><b>Free Cost Estimation</b></a></li>
                                                    <li>Floor, Carpet and Wall protection.</li>
                                                    <li>Removal of Boxes and Packing Items</li>
                                                    <li>Assembling and Disassembling of furniture</li>
                                                    <li>Highly Affordable packages to meet your needs.</li>
                                                    <li>Qualified and trained staff to handle your items with extra care</li>
                                                    <li>Licensed and Insured Company.</li>
                                                    <li>We charge from the time we leave the yard until we return</li>
                                                </ol>
                                                <p className="description text-left">This kind of moving can take 2 days depending upon the size of your move and is charged at an hourly rate based on the manpower required.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Our Pricing</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">Our local moving services are highly affordable, and we provide flex payments to larger moves. We also provide packages that are specifically tailored to meet your needs. Listed below are typical home sizes and the average amount of time it takes (on average) to complete a move. This includes 15 minutes of travel to and from your home, loading, and unloading time with average access to both pick up and destination locations.</p>                                          
                                                <p>Based on two men and a truck</p>
                                                <div className="row">
                                                <div className="col-4">
                                                    <h4>Size of Home</h4>
                                                    <ul style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                        <li>1 bedroom</li>
                                                        <li>2 bedrooms</li>
                                                        <li>3 bedrooms</li>
                                                        <li>4 Bedrooms</li>
                                                        <li>5 Bedrooms</li>
                                                    </ul>
                                                </div>
                                                <div className="col-4">
                                                    <h4>Approximate Hours</h4>
                                                    <ul style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                        <li>3 to 4 hours</li>
                                                        <li>5 to 6 hours</li>
                                                        <li>7 to 8 hours</li>
                                                        <li>8 to 10 hours</li>
                                                        <li>+10 hours</li>
                                                    </ul>
                                                </div>
                                                <div className="col-4">
                                                    <h4>Approximate Hours</h4>
                                                    <ul style={{paddingLeft:'2vh',fontSize:'20px'}}>
                                                        <li>2500 - 3000 lbs</li>
                                                        <li>4000 - 6000 lbs</li>
                                                        <li>7000 - 9000 lbs</li>
                                                        <li>10,000 - 12,000 lbs</li>
                                                        <li>+13,000 lbs</li>
                                                    </ul>
                                                </div>
                                                </div>
                                                <p className="description text-left">This kind of moving can take 2 days depending upon the size of your move and is charged at an hourly rate based on the manpower required.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-center pl--0">
                                    <div className="about-inner inner">
                                        <div className="section-title pt--100">
                                            <h3 className="text-left" style={{lineHeight:1.5}}>Book Your Move</h3>
                                        </div>
                                    
                                        <div className="row mt--30 text-left">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="description text-left pt--30">You should book your move well prior to the moving date in mind to ensure our availability. The first days, end days, and mid-days of the month are always busy for all movers as most people move in these days so the workload is greater than the usual. To secure your next move with us, you may reserve your spot by requesting a <a href="/clientinformation"><b>free estimate</b></a>. Also, you can <a href="/contact"><b>contact us</b></a> on phone, via email, or by using our <a href="/clientinformation"><b>moving calculator</b></a>, to discuss any moving matters, and to book your next move with us in advance.</p>                                          
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default LocalMoving;